module.exports = __webpack_public_path__ + "img/CS_Lite_Vol_Endspriegel.6a8b08c3.jpg";